module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "30/70"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.showEmail
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email Client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.goToTransaction
          }
        }, on), [_c('v-icon', [_vm._v("ballot")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Go to Transaction")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.goToTransaction
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {}
    }
  }, [_c('LinkNewTab', {
    attrs: {
      "link": '/client-checklist/' + _vm.checklistKey
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Client View")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToTemplates
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Templates")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToOldChecklist
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Old Checklist")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToOldChecklist
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Old Checklist")])], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-list-item', {
    on: {
      "click": _vm.downloadAllFiles
    }
  }, [_c('v-list-item-title', [_vm._v("Download All Files (Zip)")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no-print",
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_c('ChecklistMenu', {
    attrs: {
      "menu": _vm.menu
    },
    on: {
      "click": _vm.checklistMenuClicked,
      "add": _vm.addDocumentForCategory
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [_c('v-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    staticClass: "taco-column",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [(!_vm.checklistSummary.documents) ? _c('NoRecordsPlaceholder', [_vm._v("\n                    No items."), _c('br'), _vm._v("\n                    Choose one or more templates -->"), _c('br'), _vm._v("\n                    <-- Select items from the menu\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('ChecklistDetails', {
    ref: "checklistDetails",
    attrs: {
      "transactionKey": _vm.transactionKey,
      "checklistKey": _vm.checklistKey,
      "mode": _vm.checklistDetailsMode,
      "pageSettings": _vm.pageSettings
    },
    on: {
      "add-category-document": _vm.addDocumentForCategory
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "background-color": "yellow"
    }
  }, [_c('ChecklistDetails', {
    ref: "checklistHidden",
    attrs: {
      "transactionKey": _vm.transactionKey,
      "checklistKey": _vm.checklistKey,
      "mode": "Email",
      "pageSettings": _vm.pageSettings
    }
  })], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    staticClass: "no-print",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.selectedItems.length) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "color": "grey lighten-1"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.copyToClipboard($event)
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("assignment_turned_in")])], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Copy to Clipboard")])]), _vm._v(" "), _c('v-tooltip', {
    staticClass: "no-print",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.selectedItems.length) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "color": "grey lighten-1"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.showEmail($event)
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("email")])], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email to Client")])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "pa-3 no-print",
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "8px"
    },
    attrs: {
      "xxxxv-if": "transactionKey",
      "xs12": "",
      "sm12": "",
      "md5": "",
      "lg4": "",
      "row": ""
    }
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._v("Templates")]), _vm._v(" "), _c('AdvancedPanel', {
    attrs: {
      "fields": _vm.checklistDetailsPanel.fields,
      "record": _vm.checklistDetails,
      "recordRef": _vm.listRef
    },
    on: {
      "field-change": _vm.checklistDetailsFieldChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Next Followup")]), _vm._v("\n            " + _vm._s(_vm._f("dueString")(_vm.followUpTask.due)) + "\n            "), _c('Scheduler', {
    on: {
      "change": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.due),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "due", $$v)
      },
      expression: "followUpTask.due"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('UserChooser', {
    attrs: {
      "label": "Assigned To"
    },
    on: {
      "select": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.assigned),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "assigned", $$v)
      },
      expression: "followUpTask.assigned"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-heading mt-4 mb-2"
  }, [_vm._v("Checklist Comments")]), _vm._v(" "), _c('TransactionComments')], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    }
  }), _vm._v(" "), _c('AdvancedDialog', {
    attrs: {
      "record": _vm.addDocumentDialog.record,
      "settings": _vm.addDocumentDialog.settings,
      "fields": _vm.addDocumentDialog.fields
    },
    on: {
      "save": _vm.saveDocumentForCategory
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73099c7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/DocumentChecklist.vue
// module id = 2602
// module chunks = 1